import { actionSetLiveCount, actionSetLivePageviews } from '../data/action';

/**
 * @param {object} store
 * @param {object} api
 */
export function autoWebsocket(store, get) {
	let countChanged = 0;
	let pageviewPaged = {};
	get.onCount( count => {
		countChanged = count;
	});
	get.onPageviews( stats => {
		pageviewPaged = stats;
	});
	setInterval(()=>{
		if(countChanged !== false){
			store.dispatch(actionSetLiveCount(countChanged));
			countChanged = false;
		}
		if(pageviewPaged !== false){
			store.dispatch(actionSetLivePageviews(pageviewPaged));
			pageviewPaged = false;
		}
	}, 1500);
}